// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { initializePortal, getDefaultRoute } from "../routes/routeConfig";
// import { UserRoles } from "../components/Common/Sidebar";

// export const usePortalNavigation = (isLogin, currentUserDetails) => {
//   const navigate = useNavigate();
//   const roleName = UserRoles[currentUserDetails?.data?.role];

//   const [portalValue, setPortalValue] = useState(() => initializePortal());

//   useEffect(() => {
//     // Listen for localStorage changes
//     const handleStorageChange = () => {
//       const updatedPortal = localStorage.getItem("portal") || "wf";
//       setPortalValue(updatedPortal);

//       // Navigate to appropriate dashboard based on new portal mode
//       if (isLogin) {
//         const targetRoute = getDefaultRoute(updatedPortal, roleName);
//         navigate(targetRoute);
//       }
//     };

//     // Listen for custom event
//     window.addEventListener("portalChanged", handleStorageChange);
//     // Listen for storage event (for changes from other tabs)
//     window.addEventListener("storage", handleStorageChange);

//     return () => {
//       window.removeEventListener("portalChanged", handleStorageChange);
//       window.removeEventListener("storage", handleStorageChange);
//     };
//   }, [isLogin, navigate, roleName]);

//   const getDefaultRouteForCurrentPortal = (portal = portalValue) => {
//     return getDefaultRoute(portal, roleName);
//   };

//   return {
//     portalValue,
//     getDefaultRouteForCurrentPortal
//   };
// };

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { initializePortal, getDefaultRoute } from "../routes/routeConfig";
import { UserRoles } from "../components/Common/Sidebar";
import { getItem } from "../utils/localStorageUtils";

export const usePortalNavigation = (isLogin, currentUserDetails) => {
  const navigate = useNavigate();
  const roleName = UserRoles[currentUserDetails?.data?.role?.type];

  const [portalValue, setPortalValue] = useState(() => initializePortal());

  useEffect(() => {
    // Listen for localStorage changes
    const handleStorageChange = (event) => {
      // Only handle storage events from other tabs/windows
      // The 'storage' event only fires for changes from other tabs
      if (event && event.key === "portal") {
        const updatedPortal = event.newValue || "wf";
        setPortalValue(updatedPortal);

        // Navigate to appropriate dashboard based on new portal mode
        // Only navigate if the tab is currently focused to avoid unwanted redirects
        if (isLogin && document.hasFocus()) {
          const targetRoute = getDefaultRoute(updatedPortal, roleName);
          navigate(targetRoute);
        }
      }
    };

    const handleCustomPortalChange = () => {
      // Handle custom events (from same tab)
      // const updatedPortal = localStorage.getItem("portal") || "wf";
      const updatedPortal = getItem("portal") || "wf";
      setPortalValue(updatedPortal);

      // Navigate to appropriate dashboard based on new portal mode
      if (isLogin) {
        const targetRoute = getDefaultRoute(updatedPortal, roleName);
        navigate(targetRoute);
      }
    };

    // Listen for custom event (same tab changes)
    window.addEventListener("portalChanged", handleCustomPortalChange);
    // Listen for storage event (changes from other tabs)
    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("portalChanged", handleCustomPortalChange);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [isLogin, navigate, roleName]);

  const getDefaultRouteForCurrentPortal = (portal = portalValue) => {
    return getDefaultRoute(portal, roleName);
  };

  return {
    portalValue,
    getDefaultRouteForCurrentPortal,
  };
};
